import React from 'react';
import PropTypes from 'prop-types';
import { Item, Dimmer, Loader } from 'semantic-ui-react';
import { range } from 'lodash';
import css from './ConnectionPlaceholder.scss';
import profileCss from './ConnectionProfile.scss';
import headerCss from './ConnectionHeader.scss';

const HeaderPlaceholder = () => {
  return (
    <Item.Group unstackable className={headerCss['item-group-container']}>
      <Item className={headerCss['item-container']}>
        <div className={css['avatar']}>&nbsp;</div>
        <Item.Content className={headerCss['content']}>
          <div className={css['avatar-details']}>
            <p className={css['name-line']}>&nbsp;</p>
            <p className={css['secondary-line']}>&nbsp;</p>
          </div>
        </Item.Content>
      </Item>
    </Item.Group>
  );
};

const SectionPlaceholder = () => {
  return (
    <div>
      <p className={css['main-line']}>&nbsp;</p>
      <p className={css['secondary-line']}>&nbsp;</p>
    </div>
  );
};

const AboutPlaceholder = () => {
  return (
    <div className={css['about']}>
      <p className={css['main-line']}>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p className={css['secondary-line']}>&nbsp;</p>
    </div>
  );
}

const LeftPanelPlaceholder = ({numberOfSections}) => {
  return (
    <div className={profileCss['left-side']}>
      <div className={css['lines-container']}>
        {range(numberOfSections).map(index => <SectionPlaceholder key={index} />)}
      </div>
    </div>
  );
};

export default class ConnectionPlaceholder extends React.Component {

  render() {
    return (
      <Dimmer.Dimmable blurring dimmed>
        <Dimmer active inverted><Loader>Loading</Loader></Dimmer>
        <div className={css['placeholder-container']}>
          <HeaderPlaceholder />
          <div className={profileCss['connection-container']}>
            <LeftPanelPlaceholder numberOfSections={3} />
            <AboutPlaceholder />
          </div>
        </div>
      </Dimmer.Dimmable>
    );
  }
}

LeftPanelPlaceholder.propTypes = {
  numberOfSections: PropTypes.number.isRequired
};
